import theme from '../../base';

const button = {
  default: {
    borderFocused: theme.colors.blues.blue300,
  },
  disabled: {
    bg: theme.colors.neutrals.gray800,
    border: theme.colors.neutrals.gray800,
    foreground: theme.colors.neutrals.gray700,
  },
  ghost: {
    bg: theme.colors.neutrals.transparent,
    bgActive: theme.colors.neutrals.gray700,
    bgHover: theme.colors.neutrals.gray700,
    border: theme.colors.neutrals.transparent,
    borderHover: theme.colors.neutrals.gray700,
    foreground: theme.colors.neutrals.white,
    foregroundHover: theme.colors.neutrals.white,
  },
  like: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.neutrals.white,
    iconHover: theme.colors.blues.blue200,
  },
  liked: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.blues.blue300,
    iconHover: theme.colors.neutrals.white,
  },
  dislike: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.neutrals.white,
    iconHover: theme.colors.reds.red200,
  },
  disliked: {
    bg: theme.colors.neutrals.transparent,
    border: theme.colors.neutrals.transparent,
    icon: theme.colors.reds.red300,
    iconHover: theme.colors.neutrals.white,
  },
  store: {
    bg: theme.colors.secondary.secondary500,
    bgActive: theme.colors.secondary.secondary700,
    bgHover: theme.colors.secondary.secondary700,
    border: theme.colors.secondary.secondary500,
    borderHover: theme.colors.secondary.secondary700,
    foreground: theme.colors.neutrals.white,
  },
  primary: {
    bg: theme.colors.primary.primary500,
    bgActive: theme.colors.primary.primary700,
    bgHover: theme.colors.primary.primary700,
    border: theme.colors.primary.primary500,
    borderHover: theme.colors.primary.primary700,
    foreground: theme.colors.neutrals.white,
  },
  secondary: {
    bg: theme.colors.neutrals.gray800,
    bgActive: theme.colors.primary.primary500,
    bgHover: theme.colors.blues.blue300,
    border: theme.colors.blues.blue300,
    borderActive: theme.colors.primary.primary500,
    borderHover: theme.colors.primary.primary500,
    foreground: theme.colors.blues.blue200,
    foregroundHover: theme.colors.blues.blue800,
    foregroundActive: theme.colors.neutrals.white,
  },
  subtle: {
    bg: theme.colors.neutrals.gray750,
    bgHover: theme.colors.neutrals.gray700,
    border: theme.colors.neutrals.gray750,
    borderHover: theme.colors.neutrals.gray700,
    borderActive: theme.colors.neutrals.gray700,
    foreground: theme.colors.neutrals.gray500,
    foregroundHover: theme.colors.neutrals.gray500,
  },
};

export default button;
